import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "b-filter-editor container-fluid" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "col b-filter-controls align-baseline" }
const _hoisted_5 = { class: "row align-baseline" }
const _hoisted_6 = { class: "col ps-0 pe-1 align-baseline" }
const _hoisted_7 = ["onUpdate:modelValue", "onChange"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-2 px-0 align-baseline" }
const _hoisted_10 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col ps-1 pe-0 align-baseline" }
const _hoisted_13 = { class: "col b-filter-actions col-auto align-baseline d-flex align-items-center px-0" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "b-filter-button-bar mt-2" }
const _hoisted_16 = {
  key: 0,
  class: "b-filter-max-count"
}
const _hoisted_17 = ["disabled"]

import {defineComponent, watch, ref, computed} from "vue";
import type {PropType} from "vue";
import {BFilterOptions, BFilterableField, BFilter} from "./BFilterEditor.types";
import {VItem} from "../../types";


import DateField from "../Misc/DateField.vue";
import TextField from "../Misc/TextField.vue";
import ListField from "../Misc/ListField.vue";

const __default__ = {
    name: "BFilterEditor",
    components: {
        // make components available under their "editor" aliases
        TextEditor: TextField,
        ListEditor: ListField,
        DateEditor: DateField,
    },
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    fields: { default: () => [] },
    maxFilterCount: { default: 3 }
  },
  emits: ["modalDataChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const filterOptions = ref(props.value);

const filterCount = computed(() => {
    if (filterOptions.value == undefined || filterOptions.value.filters == undefined) {
        return 0;
    }

    return filterOptions.value.filters.filter((f: any) => f.property != "id").length;
});

watch(
    [filterOptions],
    ([newFilterOptions]) => {
        emit("modalDataChanged", newFilterOptions);
    },
    {deep: true}
);

const fieldItems = computed((): any[] => {
    return props.fields!.map((it) => ({
        text: it.label,
        value: it.property,
    }));
});

const canAddFilter = computed((): boolean => {
    return filterOptions.value!.filters.length < props.maxFilterCount;
});

function getFilterValue(event: any): any {
    if (event != null && event.currentTarget != null && event.currentTarget.value != null) {
        return event.currentTarget.value;
    }

    return "";
}

function operationItems(filter: BFilter): VItem[] {
    var field = props.fields.filter((it: {property: string | null}) => it.property == filter.property)[0];
    if (field == null) {
        return [];
    }
    return field.operations.map((it) => ({
        text: it.label,
        value: it.key,
        default: it.default,
    }));
}

function optionItems(filter: BFilter) {
    var field = props.fields.filter((it: {property: string | null}) => it.property == filter.property)[0];

    if (field == null) {
        return [];
    }

    return field.editorOptions;
}

function editorComponent(filter: BFilter): string {
    var field = props.fields.filter((it: {property: string | null}) => it.property == filter.property)[0];
    if (field == null) {
        return "text-editor";
    }
    return field.editorComponent;
}

function addFilter(event: any) {
    event.preventDefault();

    var newFilter = {
        property: null,
        operation: null,
        value: null,
    } as BFilter;

    if (filterOptions.value) {
        filterOptions.value.filters = [...filterOptions.value.filters, newFilter];
    }
}

function deleteFilter(index: number) {
    if (filterOptions.value) {
        filterOptions.value.filters = filterOptions.value.filters.filter((it: any, ix: number) => ix != index);
    }
}

function setFilterProperty(filter: BFilter, event: any) {
    let value = event.currentTarget.value;
    filter.property = value;
    var items = operationItems(filter);
    var defaultItem = items.find((it) => it.default);
    filter.operation = defaultItem ? defaultItem.value : items[0].value;
    filter.value = null;
}

function handleComponentChange(event: any, filter: BFilter) {
    if (event != null) {
        if (typeof event == "string") {
            filter.value = event;
        } else {
            filter.value = event.target.value;
        }
    } else {
        filter.value = "";
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (filterCount.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Add up to " + _toDisplayString(_ctx.maxFilterCount) + " search criteria.", 1))
      : _createCommentVNode("", true),
    (!filterCount.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _cache[1] || (_cache[1] = _createTextVNode("Click ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("q", null, "Add criterion", -1)),
          _createTextVNode(" button to add up to " + _toDisplayString(_ctx.maxFilterCount) + " criteria.", 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value?.filters.filter((f) => f.property != 'id'), (filter, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row b-filter-criterion align-baseline mb-2",
        key: index
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "aria-label": "filter",
                placeholder: "Field Name ",
                "onUpdate:modelValue": ($event: any) => ((filter.property) = $event),
                onChange: ($event: any) => (setFilterProperty(filter, $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.value
                  }, _toDisplayString(item.text), 9, _hoisted_8))
                }), 256))
              ], 40, _hoisted_7), [
                [_vModelSelect, filter.property]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "aria-label": "filter",
                placeholder: "Operation",
                "onUpdate:modelValue": ($event: any) => ((filter.operation) = $event),
                onChange: ($event: any) => (filter.operation = getFilterValue($event)),
                disabled: !filter.property
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationItems(filter), (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.value
                  }, _toDisplayString(item.text), 9, _hoisted_11))
                }), 256))
              ], 40, _hoisted_10), [
                [_vModelSelect, filter.operation]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(editorComponent(filter)), {
                disabled: !filter.property,
                modelValue: filter.value,
                "onUpdate:modelValue": ($event: any) => ((filter.value) = $event),
                items: optionItems(filter),
                onChange: ($event: any) => (handleComponentChange($event, filter))
              }, null, 40, ["disabled", "modelValue", "onUpdate:modelValue", "items", "onChange"]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _withModifiers(($event: any) => (deleteFilter(index)), ["prevent"]),
            class: "btn btn-link text-decoration-none"
          }, " Remove ", 8, _hoisted_14)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_15, [
      (!canAddFilter.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "You can't add more than " + _toDisplayString(_ctx.maxFilterCount) + " criteria.", 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (addFilter($event)), ["prevent"])),
        disabled: !canAddFilter.value,
        class: "btn btn-success"
      }, " Add Criterion ", 8, _hoisted_17)
    ])
  ]))
}
}

})